import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { Logo } from "./Logo";
import { scrollToId } from "@/lib/api";
import { UserMenu } from "./UserMenu";

const LINKS = [
  { id: "collections", label: "Collections" },
  { id: "catalogue", label: "Sélection" },
  { id: "top-ventes", label: "Top ventes" },
  { id: "journal", label: "Journal" },
  { id: "faq", label: "Aide" },
];

export const Header = () => {
  const [menu, setMenu] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setMenu(false);
    if (pathname !== "/") navigate(`/#${id}`);
    else scrollToId(id);
  };

  return (
    <header
      data-testid="navbar-container"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-500 border-b ${
        scrolled || menu ? "bg-[#FBF9F5]/85 backdrop-blur-xl border-[var(--line)]" : "bg-transparent border-transparent"
      }`}
    >
      <div className="mx-auto flex h-[72px] max-w-[1440px] items-center justify-between px-5 sm:px-10">
        <Link to="/" data-testid="nav-logo-link" aria-label="Accueil Kairos">
          <Logo />
        </Link>
        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <button key={l.id} data-testid={`nav-link-${l.id}`} onClick={() => go(l.id)}
              className="group relative text-sm text-[var(--ink)]">
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-full origin-left scale-x-0 bg-[var(--terra)] transition-transform duration-500 group-hover:scale-x-100" />
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <UserMenu />
          <button data-testid="mobile-menu-toggle" className="md:hidden p-2" onClick={() => setMenu((m) => !m)} aria-label="Menu">
            {menu ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {menu && (
          <motion.nav initial={{ height: 0 }} animate={{ height: "auto" }} exit={{ height: 0 }} className="overflow-hidden md:hidden">
            <div className="flex flex-col gap-1 px-5 pb-6">
              {LINKS.map((l) => (
                <button key={l.id} data-testid={`mobile-nav-link-${l.id}`} onClick={() => go(l.id)}
                  className="font-display py-2 text-left text-3xl">{l.label}</button>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
